export enum MainDistributionFrontYardPavement {
  FullGround,
  StonePavement,
  Asphalt,
  Concrete,
  OrnamentalPavement,
  Cobblestones,
  PebbleStone,
  Other,
}
